import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";

const results = [
  {
    tag: "Lost fat, built strength, and trained pain-free again.",
    name: "Ricky",
    quote:
      "I gained strength, lost fat, and felt more athletic within weeks. The structure and accountability changed everything.",
  },
  {
    tag: "Improved performance, physique, and confidence.",
    name: "Raaj",
    quote:
      "The program was customized, intense, and realistic. I could see visible progress and felt stronger every week.",
  },
  {
    tag: "More energy, better consistency, and visible body changes.",
    name: "Bhavika",
    quote:
      "This wasn't just workouts. It was coaching, guidance, and accountability that finally made me consistent.",
  },
];

export default function ResultsSection() {
  return (
    <section
      id="results"
      className="py-24 md:py-32 bg-[var(--dvx-surface)] transition-colors duration-300"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header row */}
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-8 mb-16">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
          >
            <span className="text-[var(--dvx-primary)] font-oswald text-sm uppercase tracking-widest">
              Results & Proof
            </span>
            <h2 className="mt-4 font-oswald text-4xl md:text-5xl lg:text-6xl font-bold text-[var(--dvx-text)] uppercase tracking-tight">
              Real Clients.<br />Real Transformations.
            </h2>
            <p className="mt-4 text-[var(--dvx-text-muted)] font-manrope text-lg max-w-xl">
              This page is built for action, but proof is what closes the gap between interest and commitment.
            </p>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            className="flex-shrink-0"
          >
            <Link to="/contact">
              <button className="px-8 py-4 bg-gradient-to-r from-[var(--dvx-primary)] to-[var(--dvx-primary-dark)] text-white font-oswald font-bold uppercase tracking-widest hover:scale-105 transition-transform flex items-center gap-2">
                Start My Transformation <ArrowRight size={18} />
              </button>
            </Link>
          </motion.div>
        </div>

        {/* Result cards */}
        <div className="grid md:grid-cols-3 gap-6">
          {results.map((r, i) => (
            <motion.div
              key={i}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: i * 0.12 }}
              className="bg-[var(--dvx-bg)] border border-[var(--dvx-border)] overflow-hidden"
            >
              {/* Image placeholder */}
              <div className="h-52 bg-gradient-to-br from-[var(--dvx-border)] to-[var(--dvx-surface)] flex items-center justify-center">
                <span className="text-[var(--dvx-text-muted)] font-manrope text-sm">Client Photo</span>
              </div>

              <div className="p-6">
                {/* Result tag */}
                <p className="font-oswald text-xs uppercase tracking-wider text-[var(--dvx-primary)] mb-3">
                  {r.tag}
                </p>
                {/* Name */}
                <h4 className="font-oswald text-2xl font-bold text-[var(--dvx-text)] uppercase mb-3">
                  {r.name}
                </h4>
                {/* Quote */}
                <p className="text-[var(--dvx-text-muted)] font-manrope text-sm leading-relaxed">
                  "{r.quote}"
                </p>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
